import { css, Theme } from '@emotion/react'
import { formHelperTextClasses } from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const container = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};
`

export const form = (theme: Theme) => css`
  flex: 1;

  padding: ${theme.spacing(2)};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 5)};

  background-color: ${theme.backgrounds.backgroundFive};
`

export const field = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`

export const fieldArray = (theme: Theme) => css`
  .${formHelperTextClasses.root} {
    color: ${theme.colors.red};
  }
`

export const editorWrapper = css`
  width: 100%;
`

export const editorValue = css`
  & > :first-child {
    margin-top: 0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`

export const textarea = (theme: Theme) => css`
  margin-top: ${theme.spacing(2.25)};
`

export const submitButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`
